import React, {Component} from 'react';
import './MemberApproval.css';
import {Label} from "reactstrap";

class MemberApproval extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name:""
        };
        console.log("props====>",props);
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {

        return (
            <div class="uyeOnay-container">
                <Label className="header">Girmiş olduğunuz bilgiler aşağıdaki gibidir.
                    Kontrol ettikten sonra onaylayarak başvurunuzu tamamlayabilirsiniz.</Label>
                    <table>
                        <tr>
                            <td style={{width:"30%",fontWeight:"bold",textAlign:"left"}}>Ad:</td>
                            <td style={{width:"70%",textAlign:"left"}}>{this.props.memberInfo.ad}</td>
                        </tr>
                        <tr>
                            <td style={{width:"30%",fontWeight:"bold",textAlign:"left"}}>Soyad:</td>
                            <td style={{width:"70%",textAlign:"left"}}>{this.props.memberInfo.soyad}</td>
                        </tr>
                        <tr>
                            <td style={{width:"30%",fontWeight:"bold",textAlign:"left"}}>TC Kimlik No:</td>
                            <td style={{width:"70%",textAlign:"left"}}>{this.props.memberInfo.tcKimlikNo}</td>
                        </tr>
                        <tr>
                            <td style={{width:"30%",fontWeight:"bold",textAlign:"left"}}>Doğum Tarihi:</td>
                            <td style={{width:"70%",textAlign:"left"}}>{ (this.props.memberInfo.dogumTarihi) && new Date(this.props.memberInfo.dogumTarihi).toLocaleDateString('tr')}</td>
                        </tr>
                        <tr>
                            <td style={{width:"30%",fontWeight:"bold",textAlign:"left"}}>N.Cüzdanı/Kimlik Seri No:</td>
                            <td style={{width:"70%",textAlign:"left"}}>{this.props.memberInfo.cuzdanKimlikSeriNo}</td>
                        </tr>
                        <tr>
                            <td style={{width:"30%",fontWeight:"bold",textAlign:"left"}}>Kimlik Kayıt No:</td>
                            <td style={{width:"70%",textAlign:"left"}}>{this.props.memberInfo.kayitNo}</td>
                        </tr>
                        <tr>
                            <td style={{width:"30%",fontWeight:"bold",textAlign:"left"}}>Doğum Tarihi:</td>
                            <td style={{width:"70%",textAlign:"left"}}>{ (this.props.memberInfo.kimlikSonGecerlilikTarihi) && new Date(this.props.memberInfo.kimlikSonGecerlilikTarihi).toLocaleDateString('tr')}</td>
                        </tr>
                       <tr>
                            <td style={{width:"30%",fontWeight:"bold",textAlign:"left"}}>Baba Adı:</td>
                            <td style={{width:"70%",textAlign:"left"}}>{this.props.memberInfo.babaAdi}</td>
                        </tr>
                        <tr>
                            <td style={{width:"30%",fontWeight:"bold",textAlign:"left"}}>Ana Adı:</td>
                            <td style={{width:"70%",textAlign:"left"}}>{this.props.memberInfo.anaAdi}</td>
                        </tr>
                        <tr>
                            <td style={{width:"30%",fontWeight:"bold",textAlign:"left"}}>Doğum Yeri:</td>
                            <td style={{width:"70%",textAlign:"left"}}>{this.props.memberInfo.dogumYeri}</td>
                        </tr>
                        <tr>
                            <td style={{width:"30%",fontWeight:"bold",textAlign:"left"}}>Medeni Hali:</td>
                            <td style={{width:"70%",textAlign:"left"}}>{this.props.memberInfo.medeniHali}</td>
                        </tr>
                        <tr>
                            <td style={{width:"30%",fontWeight:"bold",textAlign:"left"}}>Kan Grubu:</td>
                            <td style={{width:"70%",textAlign:"left"}}>{this.props.memberInfo.kanGrubu}</td>
                        </tr>
                        <tr>
                            <td style={{width:"30%",fontWeight:"bold",textAlign:"left"}}>Cep Telefonu:</td>
                            <td style={{width:"70%",textAlign:"left"}}>{this.props.memberInfo.gsmTel}</td>
                        </tr>
                        <tr>
                            <td style={{width:"30%",fontWeight:"bold",textAlign:"left"}}>İş Telefonu:</td>
                            <td style={{width:"70%",textAlign:"left"}}>{this.props.memberInfo.isTel}</td>
                        </tr>
                        <tr>
                            <td style={{width:"30%",fontWeight:"bold",textAlign:"left"}}>Ev Telefonu:</td>
                            <td style={{width:"70%",textAlign:"left"}}>{this.props.memberInfo.evTel}</td>
                        </tr>
                        <tr>
                            <td style={{width:"30%",fontWeight:"bold",textAlign:"left"}}>İş Adresi:</td>
                            <td style={{width:"70%",textAlign:"left"}}>{this.props.memberInfo.isAdres}</td>
                        </tr>
                        <tr>
                            <td style={{width:"30%",fontWeight:"bold",textAlign:"left"}}>İkamet Adresi:</td>
                            <td style={{width:"70%",textAlign:"left"}}>{this.props.memberInfo.ikametAdres}</td>
                        </tr>
                        <tr>
                            <td style={{width:"30%",fontWeight:"bold",textAlign:"left"}}>Üniversite:</td>
                            <td style={{width:"70%",textAlign:"left"}}>{this.props.memberInfo.universite}</td>
                        </tr>
                        <tr>
                            <td style={{width:"30%",fontWeight:"bold",textAlign:"left"}}>Doğum Tarihi:</td>
                            <td style={{width:"70%",textAlign:"left"}}>{ (this.props.memberInfo.mezuniyetTarihi) && new Date(this.props.memberInfo.mezuniyetTarihi).toLocaleDateString('tr')}</td>
                        </tr>
                        <tr>
                            <td style={{width:"30%",fontWeight:"bold",textAlign:"left"}}>Diploma No:</td>
                            <td style={{width:"70%",textAlign:"left"}}>{this.props.memberInfo.diplomaNo}</td>
                        </tr>
                        <tr>
                            <td style={{width:"30%",fontWeight:"bold",textAlign:"left"}}>Doğum Tarihi:</td>
                            <td style={{width:"70%",textAlign:"left"}}>{ (this.props.memberInfo.ruhsatTarihi) && new Date(this.props.memberInfo.ruhsatTarihi).toLocaleDateString('tr')}</td>
                        </tr>
                        <tr>
                            <td style={{width:"30%",fontWeight:"bold",textAlign:"left"}}>Ruhsat No:</td>
                            <td style={{width:"70%",textAlign:"left"}}>{this.props.memberInfo.ruhsatNo}</td>
                        </tr>
                        <tr>
                            <td style={{width:"30%",fontWeight:"bold",textAlign:"left"}}>Vergi Dairesi Adı:</td>
                            <td style={{width:"70%",textAlign:"left"}}>{this.props.memberInfo.vergiDairesiAd}</td>
                        </tr>
                        <tr>
                            <td style={{width:"30%",fontWeight:"bold",textAlign:"left"}}>Vergi No:</td>
                            <td style={{width:"70%",textAlign:"left"}}>{this.props.memberInfo.vergiNo}</td>
                        </tr>
                    </table>
            </div>
        );
    }


}
export default MemberApproval;



// WEBPACK FOOTER //
// ./src/page/memberApproval/MemberApproval.js